import { logError } from '@node-space/utils'
import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPaymentCaseDocument } from 'services/PaymentsService'

export const usePaymentCaseDocumentQuery = (paymentDocumentId: string) => {
  return useQuery(
    reactQueryKeys.paymentCaseDocument(paymentDocumentId),
    () => getPaymentCaseDocument(paymentDocumentId),
    {
      enabled: false,
      cacheTime: 0,
      onError: (error: unknown) => {
        logError('Error: usePaymentCaseDocumentQuery', error)
      },
    }
  )
}
